import * as React from 'react';

interface Props {
    onSearch: (searchTerm: string | number) => void;
    searchPlaceHolder?: string;
    clearButton: string;
}
/* tslint:disable */
interface State {
    warning: string;
    timeout: any;
    theSearchVal: string | number;
}

class TableSearch extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            warning: 'TODO',
            timeout: null,
            theSearchVal: ''
        };
        this.onChangeSearchInput = this.onChangeSearchInput.bind(this);
        this.clear = this.clear.bind(this);
    }

    clear() {
        this.props.onSearch('');
        this.setState({ theSearchVal: '' });
    }

    onChangeSearchInput(e: React.ChangeEvent<HTMLInputElement>) {
        if (this.state.timeout !== null) {
            this.setState({ timeout: clearTimeout(this.state.timeout), theSearchVal: e.target.value });
        }
        this.setState({ timeout: setTimeout(() => this.props.onSearch(this.state.theSearchVal), 250), theSearchVal: e.target.value });
    }

    public render() {
        return (
            <div>
                <div className="input-group mb-3">
                    <input
                        value={this.state.theSearchVal}
                        onChange={this.onChangeSearchInput}
                        type="string"
                        className="form-control inText"
                        placeholder={this.props.searchPlaceHolder}
                        aria-describedby="basic-addon2"
                    />
                    <span className="input-group-append">
                        <button
                            onClick={this.clear}
                            className="btn btn-outline-secondary"
                            type="button"
                        >
                            {this.props.clearButton}
                        </button>
                    </span>
                </div>
            </div>
        );
    }
}

export default TableSearch;
/* tslint:disable */


// WEBPACK FOOTER //
// ./src/components/table/search.tsx